import i18n from '../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class LotExportImagesTemplateModel extends BaseModel {
    filename_templates = null;

    rules = {
        filename_templates: 'required'
    };

    attributeLabels = {
        filename_templates: i18n.t('Filename template')
    };

    attributeHints = {};

    constructor(data = {}) {
        super();

        Object.assign(this, {...data});
    }
}
